import styled from '@emotion/styled'

export const PageWrapper = styled('div')`
  background: white;
  height: 100vh;
`

export const Form = styled('form')`
  margin-top: 6px;
`

export const CopySectionWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: flex-center;
  gap: 8px;
  *:first-child {
    margin-right: auto;
  }
`
